<template>
  <div style="position: relative; width: 100%">
    <el-dropdown
      @visible-change="visibleChange"
      max-height="20vh"
      placement="bottom-start"
      ref="addressesDropdownRef"
      trigger="contextmenu"
      @command="updateAddressFromDropdown"
      class="addressFromDropdown"
    >
      <div class="dropdown-input-area"></div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-for="(option, index) in suggestedAddresses" :key="index" :command="option" :disabled="option.disabled" :class="option.class">
            {{ option.value }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <input
      class="inputCustom"
      ref="inputRef"
      @focus="isFocusedInput = true"
      :value="input"
      @input="onInput"
      @blur="onBlur"
      placeholder="Введите адрес"
      v-cancel-read-only
      autocomplete="do-not-autofill"
    />
  </div>
</template>

<script setup>
import { ADDRESS } from '@/remotes';
import { debounce } from '@/utils/setDebounce';
import { ref, watch } from 'vue';

const props = defineProps({
  address: Object,
  city: Object,
  modalState: Boolean,
  onCommandClick: Function,
});

const suggestedAddresses = ref([]);
const addressesDropdownRef = ref();
const inputRef = ref();

const isFocusedInput = ref(false);
const input = ref('');

// const isDropdownListOpen = ref(false);

const visibleChange = (isOpen) => {
  if (!isOpen && !props.address?.value && !isFocusedInput.value) {
    input.value = '';
  }
};

const updateAddressFromDropdown = (value) => {
  emit('update:address', value);
  props.onCommandClick();

  inputRef.value.focus();

  setTimeout(() => {
    inputRef.value.focus();
  }, 300);
};

watch(
  () => props.address,
  (newVal) => {
    if (newVal?.value) {
      input.value = newVal.value + ' ';
    } else {
      input.value = '';
    }
  }
);

watch(
  () => props.modalState,
  () => {
    if (props.address?.value) {
      input.value = props.address.value;
    } else {
      input.value = '';
    }
  }
);

const onBlur = () => {
  isFocusedInput.value = false;
  if (input.value === '') {
    emit('update:address', null);
  } else {
    if (props.address?.value) {
      input.value = props.address.value;
    }
  }
};

const onInput = (e) => {
  const newVal = e.target.value;
  input.value = newVal;
  if (newVal === '') {
    emit('update:address', null);
  }
  getAddresses(newVal);
};

const emit = defineEmits(['update:address']);

const getLocations = () => {
  let cityTitle = props.city.title;
  const regex = /\((.*?)\)/;
  const match = cityTitle.match(regex);
  let settlement = '';
  const street = props.address?.data?.street || null;
  if (match && match.length > 1) {
    settlement = match[1];
    cityTitle = cityTitle.split(' ')[0];
    return [
      {
        settlement,
        street,
      },
      {
        city: settlement,
        street,
      },
      {
        settlement: cityTitle,
        street,
      },
      {
        city: cityTitle,
        street,
      },
    ];
  }
  return [{ city: cityTitle, street }];
};

async function fetchAddressList(value) {
  if (value.length) {
    try {
      const { data } = await ADDRESS.post('4_1/rs/suggest/address', {
        query: value,
        locations: getLocations(),
      });
      suggestedAddresses.value = data.suggestions;

      if (suggestedAddresses.value.length < 1) {
        suggestedAddresses.value[0] = {
          disabled: true,
          class: 'disable-notice',
          value: 'Нет результатов',
        };

        addressesDropdownRef.value.handleOpen();
      } else {
        suggestedAddresses.value.unshift({
          disabled: true,
          class: 'disable-notice',
          value: 'Выберите нужный адрес',
        });
        addressesDropdownRef.value.handleOpen();
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    addressesDropdownRef.value.handleClose();
  }
}

const fetchAddressDebounce = debounce(fetchAddressList, 500);

const getAddresses = (value) => {
  if (value.length < 1) {
    addressesDropdownRef.value.handleClose();
    suggestedAddresses.value = [];
  } else {
    addressesDropdownRef.value.handleOpen();
    suggestedAddresses.value[0] = { disabled: true, class: 'disable-notice', value: 'Поиск...' };
  }
  fetchAddressDebounce(value, props.city);
};
</script>

<style scoped></style>
